import { render, staticRenderFns } from "./Signaturepad.vue?vue&type=template&id=3cf2fcc6"
import script from "./Signaturepad.vue?vue&type=script&lang=js"
export * from "./Signaturepad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports